export const ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY = 'onboarding_redirect_to_after_complete';
